import { createSharedState } from 'Shared/use-shared-state';

export const selectedOptionSlice = createSharedState('selectedOption');
export const useSelectedOption = selectedOptionSlice.hook;

export const internationalBuyBoxSlice = createSharedState('internationalBuyBoxVisible', null);
export const useInternationalBuyBox = internationalBuyBoxSlice.hook;
